import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Reveal } from "../components/site/Reveal";
import { useTitle } from "../App";

const Block = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-display text-xl font-semibold text-mist">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-400">{children}</div>
  </div>
);

const Shell = ({ title, intro, children, testid }) => (
  <div data-testid={testid} className="bg-midnight text-mist">
    <Navbar />
    <section className="grain pt-[76px]">
      <div className="container-ek max-w-3xl py-24 sm:py-28">
        <Reveal>
          <p className="eyebrow mb-4">Legal</p>
          <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">{title}</h1>
          <p className="mt-6 text-base leading-relaxed text-slate-400">{intro}</p>
        </Reveal>
        <Reveal delay={0.1}>{children}</Reveal>
      </div>
    </section>
    <Footer />
  </div>
);

export function Privacy() {
  useTitle("Privacy");
  return (
    <Shell testid="privacy-page" title="Privacy Notice"
      intro="This notice explains what Ekavrix Tech Ventures collects through this website, why, and the choices you have. It is written to be read, not to hide in.">
      <Block title="What we collect">
        <p>When you submit an enquiry, we store the details you provide: name, email, optional phone number, enquiry category, optional company details and your message. We also record the page you enquired from, the time of submission, and campaign attribution (UTM parameters) when present.</p>
        <p>We collect basic, anonymised interaction events — such as which venture pages are opened and when a form is started or submitted — to understand how the site is used. These events never include your message content or contact details.</p>
      </Block>
      <Block title="Why we collect it">
        <p>Enquiry details exist for one reason: so we can respond to you properly and manage that conversation over time. Promotional updates are sent only if you explicitly opt in on the form; enquiry consent and marketing consent are separate.</p>
      </Block>
      <Block title="How it is stored and who sees it">
        <p>Enquiries are stored in a private database accessible only to authorised Ekavrix administrators. We do not sell or rent your details. Messages are treated as private correspondence.</p>
      </Block>
      <Block title="Your choices">
        <p>You may ask us to view, correct or delete your enquiry data at any time by contacting us through the channels published on this site. Where optional integrations (such as email notifications or spreadsheet sync) are configured by the site owner, they process enquiry data solely to deliver the notification.</p>
      </Block>
      <Block title="Changes">
        <p>If this notice changes materially, the updated version will be published on this page with a revised date. Last updated: July 2026.</p>
      </Block>
    </Shell>
  );
}

export function Terms() {
  useTitle("Terms");
  return (
    <Shell testid="terms-page" title="Terms of Use"
      intro="These terms govern your use of the Ekavrix website. By using the site you accept them; if you do not, please do not use the site.">
      <Block title="What this site is">
        <p>This website introduces Ekavrix Tech Ventures, its ventures and its services. Content describing products or ventures that are in development is identified as such and does not constitute an offer of a live product, service availability, pricing or results.</p>
      </Block>
      <Block title="No professional or outcome guarantees">
        <p>Nothing on this site guarantees business results, marketing performance, travel availability, fitness outcomes or any other specific result. Engagements are defined individually in writing before work begins.</p>
      </Block>
      <Block title="Intellectual property">
        <p>The Ekavrix name, wordmark, site design and original copy belong to Ekavrix Tech Ventures. You may not reuse them without written permission. No trademark exclusivity is claimed beyond what law provides.</p>
      </Block>
      <Block title="Enquiries">
        <p>Submitting an enquiry creates a record we use to respond to you, as described in the Privacy Notice. Please do not submit confidential information belonging to third parties.</p>
      </Block>
      <Block title="Changes">
        <p>We may update these terms from time to time; the current version always lives on this page. Last updated: July 2026.</p>
      </Block>
    </Shell>
  );
}
